"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _releaseImportDialog = _interopRequireDefault(require("./components/releaseImportDialog"));
var _filterColumn = _interopRequireDefault(require("@/components/filterColumn"));
var _SailScheduleOne = _interopRequireDefault(require("@/components/SailScheduleOne"));
var _vuex = require("vuex");
var _utils = require("@/utils");
var _booking = require("@/api/bookSpace/booking");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "releaseApply",
  components: {
    sailSchedule: _SailScheduleOne.default,
    filterColumn: _filterColumn.default,
    releaseImportDialog: _releaseImportDialog.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      releaseImportDialogVisible: false,
      sailScheduleDialogVisible: false,
      total: 0,
      filterForm: {},
      listQuery: {
        vesselCode: '',
        voyageNo: '',
        voyageLeg: '',
        releaseWay: '2',
        currentPage: 1,
        pageSize: 100,
        blNo: '',
        // vesselName:'',
        porFormat: '4',
        polFormat: '4',
        podFormat: '4',
        delFormat: '4'
      },
      idData: '',
      tableData: [],
      hotSettings: {
        dragCheck: true,
        height: 'calc(100vh - 390px)',
        width: '100%',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      logStateList: [{
        displayValue: 'Submit',
        displayValueCn: '已提交',
        codeValue: '00'
      }, {
        displayValue: 'PASS',
        displayValueCn: '已通过',
        codeValue: '01'
      }, {
        displayValue: 'REJECT',
        displayValueCn: '已拒绝',
        codeValue: '02'
      }],
      releaseWayList: [],
      reportList: [],
      deliveryList: [],
      releaseStatus: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    var _this = this;
    this.$dictionary.get(['RELEASE_STATUS', 'DOC_RELEASE_WAY', 'DOC_PORT_FORMAT', 'DELIVERY_DOCMENT_METHOD'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.releaseWayList = res.DOC_RELEASE_WAY;
      _this.deliveryList = res.DELIVERY_DOCMENT_METHOD;
      _this.reportList = res.DOC_PORT_FORMAT;
      //  遍历codeValue的值改为数字类型
      _this.releaseStatus = res.RELEASE_STATUS;

      // soc
    });
  },
  activated: function activated() {
    this.handleInitParams();
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      _this2.resizeHotTable();
      _this2.handleInitParams();
    });
  },
  methods: {
    handleInitParams: function handleInitParams() {
      var data = this.$route.query.releaseParams;
      if (data) {
        var releaseParams = JSON.parse(data);
        console.log('releaseParams', releaseParams);
        if (releaseParams) {
          this.listQuery.vesselCode = releaseParams.vesselCode;
          this.listQuery.vesselName = releaseParams.vesselName;
          this.listQuery.voyageLeg = releaseParams.voyageLeg;
          this.listQuery.voyageNo = releaseParams.voyageNo;
          this.listQuery.blNo = releaseParams.blNo || null;
          this.handleSearch();
        }
      }
    },
    handleOpenVesselSearch: function handleOpenVesselSearch() {
      this.sailScheduleDialogType = 'search';
      this.sailScheduleDialogVisible = true;
    },
    handleResetView: function handleResetView() {
      var _this3 = this;
      if (!this.handleValistLength(1)) {
        return;
      }
      var selectData = this.$refs.hotTable.getSelections();
      var blNo = selectData.map(function (item) {
        return item.blNo;
      }).join(',');
      this.loading = (0, _utils.load)();
      (0, _booking.searchReleaseHistoryDownload)(blNo).then(function (res) {
        var url = window.URL.createObjectURL(res);
        var elink = document.createElement('a');
        elink.style.display = 'none';
        elink.download = res.fileName;
        elink.href = url;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
        _this3.$message.success(_this3.$t('home.downloadSuccess'));
      }).finally(function () {
        _this3.loading.close();
      });
    },
    handleReleaseViewUpload: function handleReleaseViewUpload() {
      if (!this.handleValistLength(1)) {
        return;
      }
      var selectData = this.$refs.hotTable.getSelections();
      var flag = selectData.some(function (item) {
        return item.logState === '01';
      });
      if (flag) {
        this.$message.warning(this.$t('home.warningLogStateUpload'));
        return;
      }
      this.idData = selectData.map(function (item) {
        return item.bookingHeadWebComId;
      }).join(',');
      this.releaseImportDialogVisible = true;
    },
    handleValistLength: function handleValistLength(type) {
      if (this.$refs.hotTable.getSelections().length < 1) {
        if (type === 1) {
          this.$message.warning(this.$t('home.warningReleaseView'));
          return false;
        } else {
          this.$message.warning(this.$t('home.warning'));
          return false;
        }
      }
      return true;
    },
    handleRelease: function handleRelease() {
      var _this4 = this;
      if (!this.handleValistLength()) {
        return;
      }
      var selectData = this.$refs.hotTable.getSelections();
      var KRXXXFlag = selectData.some(function (item) {
        return item.pol.startsWith('KR');
      });
      if (KRXXXFlag && (this.listQuery.releaseWay === '3' || this.listQuery.releaseWay === '1')) {
        this.$message.warning(this.$t('home.KRXXXreleaseApply'));
        return;
      }
      if (this.listQuery.releaseWay === '3') {
        var noSeaWaybillFlag = selectData.some(function (item) {
          return item.deliveryDocumentMethod !== '2';
        });
        if (noSeaWaybillFlag) {
          return this.$message.warning(this.$t('home.seaWaybillValid'));
        }
      }
      this.idData = selectData.map(function (item) {
        return item.bookingHeadWebComId;
      }).join(',');
      var data = {
        bookingHeadWebIds: this.idData,
        releaseWay: this.listQuery.releaseWay,
        porFormat: this.listQuery.porFormat,
        polFormat: this.listQuery.polFormat,
        podFormat: this.listQuery.podFormat,
        delFormat: this.listQuery.delFormat
      };
      this.loading = (0, _utils.load)();
      (0, _booking.searchReleaseHistorySaves)(data).then(function (res) {
        _this4.$message.success(_this4.$t('home.successRelease'));
        _this4.handleSearch();
      }).finally(function () {
        _this4.loading.close();
      });
    },
    selectionChange: function selectionChange(row) {
      this.sailScheduleDialogVisible = false;
      this.listQuery.vesselCode = row.vesselCode;
      this.listQuery.vesselName = row.vesselName;
      this.listQuery.voyageLeg = row.voyageLeg;
      this.listQuery.voyageNo = row.voyageNo;
    },
    handleOpenVessel: function handleOpenVessel() {
      this.sailScheduleDialogVisible = true;
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable.resizeTo();
    },
    handleSearch: function handleSearch() {
      var _this5 = this;
      if (!this.listQuery.vesselCode && !this.listQuery.vesselName && !this.listQuery.voyageLeg && !this.listQuery.voyageNo && !this.listQuery.blNo) {
        this.$message.warning(this.$t('home.warningRelease'));
        return;
      }
      this.loading = (0, _utils.load)();
      (0, _booking.searchReleaseHistory)(this.listQuery).then(function (res) {
        console.log(' res.data.records', res.data.records);
        _this5.tableData = res.data.records;
        _this5.tableData = res.data.records.map(function (item) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
            releaseStatus: String(item.releaseStatus),
            logState: String(item.logState),
            deliveryDocumentMethod: String(item.deliveryDocumentMethod)
          });
        });
        _this5.total = res.data.totalRecord;
      }).finally(function () {
        _this5.loading.close();
      });

      // this.tableData = [{
      //   amount: 100,
      //   feeState: 'Paid',
      //   bankSlipState: 'Uploaded',
      //   applyInvoiceState: 'Pending',
      //   bkNo: 'BK123456',
      //   blNo: 'BL123456',
      //   vesselCode: 'VES001',
      //   voyageNo: 'VY001',
      //   voyageLeg: 'Leg1',
      //   pol: 'Port1',
      //   etdOrg: '2024-06-20',
      //   pod: 'Port2',
      //   eta: '2024-06-22',
      //   del: 'DEL1',
      //   auditRemark: 'Remark1',
      //   auditRemark2: 'Remark2',
      // },
      //   {
      //     amount: 200,
      //     feeState: 'Unpaid',
      //     bankSlipState: 'Not Uploaded',
      //     applyInvoiceState: 'Approved',
      //     bkNo: 'BK654321',
      //     blNo: 'BL654321',
      //     vesselCode: 'VES002',
      //     voyageNo: 'VY002',
      //     voyageLeg: 'Leg2',
      //     pol: 'Port3',
      //     etdOrg: '2024-07-01',
      //     pod: 'Port4',
      //     eta: '2024-07-03',
      //     del: 'DEL2',
      //     auditRemark: 'Remark3',
      //     auditRemark2: 'Remark4',
      //   },
      //   {
      //     amount: 150,
      //     feeState: 'Partially Paid',
      //     bankSlipState: 'Uploaded',
      //     applyInvoiceState: 'Rejected',
      //     bkNo: 'BK789456',
      //     blNo: 'BL789456',
      //     vesselCode: 'VES003',
      //     voyageNo: 'VY003',
      //     voyageLeg: 'Leg3',
      //     pol: 'Port5',
      //     etdOrg: '2024-08-15',
      //     pod: 'Port6',
      //     eta: '2024-08-17',
      //     del: 'DEL3',
      //     auditRemark: 'Remark5',
      //     auditRemark2: 'Remark6',
      //   },
      //   {
      //     amount: 250,
      //     feeState: 'Paid',
      //     bankSlipState: 'Uploaded',
      //     applyInvoiceState: 'Pending',
      //     bkNo: 'BK321654',
      //     blNo: 'BL321654',
      //     vesselCode: 'VES004',
      //     voyageNo: 'VY004',
      //     voyageLeg: 'Leg4',
      //     pol: 'Port7',
      //     etdOrg: '2024-09-10',
      //     pod: 'Port8',
      //     eta: '2024-09-12',
      //     del: 'DEL4',
      //     auditRemark: 'Remark7',
      //     auditRemark2: 'Remark8',
      //   }]
    },
    handleReset: function handleReset() {
      this.listQuery.vesselCode = '';
      this.listQuery.vesselName = '';
      this.listQuery.voyageLeg = '';
      this.listQuery.voyageNo = '';
      this.listQuery.blNo = '';
      this.listQuery.currentPage = 1;
      this.listQuery.pageSize = 100;
    },
    handleFeeConfirmation: function handleFeeConfirmation() {},
    handleBankSlipUpload: function handleBankSlipUpload() {
      this.bankSlipUploadDlgVisible = true;
    },
    handleApplyInvoice: function handleApplyInvoice() {
      this.invoiceApplyDlgVisible = true;
    },
    handleUploadInvoice: function handleUploadInvoice() {
      this.uploadInvoiceDlgVisible = true;
    },
    handleSizeChange: function handleSizeChange() {},
    handleCurrentChange: function handleCurrentChange() {}
  }
};